module.exports = __webpack_public_path__ + "img/notfound.88076bd4.svg";